<template>
  <b-container fluid class="bv-example-row orderHistory">
    <b-row>
      <b-col class="page-info">
        <div class="page-info-title">{{ $t('orderHistory.todaysOrderHistory') }}</div>
        <div class="page-info-description">
          {{ $t('orderHistory.orderHistoryOfThisWholeTableWillBeDisplayed') }}
        </div>
        <div class="page-info-description">
          <img src="@/assets/images/icn_smartphone.svg" alt width="20" />
          {{ $t('orderHistory.orderFromSmartphone') }}
        </div>
      </b-col>
    </b-row>
    <b-row
      v-for="order in history"
      :key="order.id"
      :order="order"
      class="history-list"
      align-v="center"
      :class="{ orderFromSmartOrder: order.orderFrom === 2 }"
    >
      <b-col cols="1">
        <div v-if="order.orderFrom === 2" class="history-list-icon">
          <img src="@/assets/images/icn_smartphone.svg" alt />
        </div>
      </b-col>
      <b-col cols="5" style="padding-right: 5px">
        <div class="history-list-title">{{ order.itemName }}</div>
        <div class="history-list-topping">{{ toppingNames(order.toppings) }}</div>
      </b-col>
      <b-col cols="2" style="padding-right: 5px; padding-left: 5px">
        <div class="history-list-dish">
          <span>{{ order.quantity }}</span>
          <template v-if="!isJa">{{ unit[order.unit] }}</template>
        </div>
      </b-col>
      <b-col cols="4" style="padding-left: 5px">
        <div v-if="order.status === orderStatuses.arriveComplete" class="history-list-delivery">
          {{ order.arrivalAt | hhmmss }}
          <br />
          {{ $t('orderHistory.arrived') }}
        </div>
        <div v-if="order.status === orderStatuses.orderPending" class="history-list-button">
          <div class="history-list-button_cancel" @click="showCancelModdal(order.id)">
            {{ $t('common.cancel') }}
          </div>
        </div>
      </b-col>
    </b-row>
    <order-cancel-modal :id="cancelTarget" @cancelButtonClicked="cancelOrder" />
  </b-container>
</template>
<script>
import OrderCancelModal from '@/components/modal/OrderCancelModal'
// config
import config from '@/config/config'
import { ORDER_STATUSES } from '@/consts'
// module
import * as api from '@/api'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { getLocalDateTimeQuery } from '@/utils/time'

export default {
  components: {
    OrderCancelModal,
  },
  filters: {
    hhmmss(date) {
      return moment(date).format('HH:mm:ss')
    },
  },
  data() {
    return {
      history: [],
      cancelTarget: null,
    }
  },
  computed: {
    unit() {
      return config.unit[this.languageId]
    },
    checkedInAtYYYYMMDD() {
      return getLocalDateTimeQuery(this.checkedInAt)
    },
    ...mapGetters({
      checkedInAt: 'seat/getCheckedInAt',
      languageId: 'setting/getLanguage',
      shopId: 'seat/getShopId',
      seatNo: 'seat/getSeatNo',
    }),
    orderStatuses() {
      return ORDER_STATUSES
    },
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJa() {
      return this.defaultLanguage === 'ja'
    },
  },
  watch: {
    // 言語が変更されるとその言語で履歴を取得しなおし
    languageId() {
      this.fetchHistory()
    },
    seatNo(seatNo) {
      if (seatNo !== null) {
        this.fetchHistory()
      }
    },
  },
  mounted() {
    if (this.seatNo !== null) {
      this.fetchHistory()
    }
  },
  methods: {
    toppingNames(toppings) {
      var toppingNames = toppings.map((topping) => topping.name)
      return toppingNames.join(' ')
    },
    showCancelModdal(id) {
      this.cancelTarget = id
      this.$bvModal.show('order-cancel-modal')
    },
    cancelOrder(orderId) {
      api
        .orderMenuCancel(this.shopId, orderId)
        .then(() => {
          // console.log(res)
        })
        .catch(() => {
          // console.log('xxx')
        })
        .finally(() => {
          // いずれにしろ最新状態にする
          this.fetchHistory()
        })
    },
    fetchHistory() {
      if (this.seatNo === 0) {
        // 事前注文の場合は事前注文一覧取得APIを実行する
        api.fetchPreOrderHistory(this.shopId).then((res) => {
          this.history = res.data.list
        })
      } else {
        api.fetchHistory(this.shopId, this.seatNo, this.checkedInAtYYYYMMDD).then((res) => {
          this.history = res.data.list
        })
      }
    },
  },
}
</script>
<style lang="scss">
body {
  .orderHistory {
    .page-info-description {
      padding-bottom: 10px;
      img {
        display: inline-block;
        margin: -2px 3px 0 -3px;
      }
      + .page-info-description {
        padding-bottom: 15px;
      }
    }
  }
}
.history-list {
  padding-left: 5px;

  &.orderFromSmartOrder {
    padding-left: 0;
    border-left: 5px solid red;
  }
  .col-1 {
    padding: 0;
    padding-left: 10px;

    img {
      display: block;
      margin: 0 auto;
      max-width: 24px;
    }
  }
}
</style>
